import {
  FETCH_MENUS,
  FETCH_NEW_MENUS,
  FETCH_FEATURE_MENUS,
  FETCH_TAXONOMY_MENUS,
  FETCH_SAME_CATEGORY_MENUS,
  FETCH_FAVORITED_MENUS,
  FETCH_MENU,
  ERROR_MENU,
  RESET_MENUS
} from '@/actions/actionTypes';
import {
  fetchMenusEntries,
  fetchNewMenusEntries,
  fetchFeatureMenusEntries,
  fetchTaxonomyMenusEntries,
  fetchSameCategoryMenusEntries,
  fetchFavoritedMenusEntries,
  fetchMenuEntry
} from '@/domains/contentful/menu';
import { IMenu } from '@/@types/generated/contentful';
import { AppDispatch } from '@/store/configureStore';
import _ from 'lodash';

/**
 * Action Creator
 */
export const innerFetchMenus = (menuList: IMenu[]) => ({
  type: FETCH_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchNewMenus = (menuList: IMenu[]) => ({
  type: FETCH_NEW_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchFeatureMenus = (menuList: IMenu[]) => ({
  type: FETCH_FEATURE_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchTaxonomyMenus = (menuList: IMenu[]) => ({
  type: FETCH_TAXONOMY_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchSameCategoryMenus = (menuList: IMenu[]) => ({
  type: FETCH_SAME_CATEGORY_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchFavoritedMenus = (menuList: IMenu[]) => ({
  type: FETCH_FAVORITED_MENUS,
  payload: {
    menuList
  }
});

export const innerFetchMenu = (menu: IMenu) => ({
  type: FETCH_MENU,
  payload: {
    menu
  }
});

export const innerErrorMenu = () => ({
  type: ERROR_MENU
});

export const innerResetMenus = () => ({
  type: RESET_MENUS
});

/**
 * Action
 */
export const fetchMenus = () => async (dispatch: AppDispatch) => {
  const menuList = await fetchMenusEntries();
  dispatch(innerFetchMenus(menuList));
};

export const fetchNewMenus = (limit: number) => async (dispatch: AppDispatch) => {
  const menuList = await fetchNewMenusEntries(limit);
  dispatch(innerFetchNewMenus(menuList));
};

export const fetchFeatureMenus = (features: string[]) => async (dispatch: AppDispatch) => {
  if (features.length === 0) return;
  const menuList = await fetchFeatureMenusEntries(features);
  dispatch(innerFetchFeatureMenus(menuList));
};

export const fetchTaxonomyMenus = (taxonomy?: string | string[]) => async (
  dispatch: AppDispatch
) => {
  if (!taxonomy || _.isArray(taxonomy)) return;
  const menuList = await fetchTaxonomyMenusEntries(taxonomy);
  dispatch(innerFetchTaxonomyMenus(menuList));
};

export const fetchSameCategoryMenus = ({
  menuCat,
  menuId
}: {
  menuCat: string;
  menuId: string;
}) => async (dispatch: AppDispatch) => {
  const menuList = await fetchSameCategoryMenusEntries({ menuCat, menuId });
  dispatch(innerFetchSameCategoryMenus(menuList));
};

export const fetchFavoritedMenus = (favoritedList: string[]) => async (dispatch: AppDispatch) => {
  const menuList = await fetchFavoritedMenusEntries(favoritedList);
  await dispatch(innerFetchFavoritedMenus(menuList));
};

export const fetchMenu = (slug?: string | string[]) => async (dispatch: AppDispatch) => {
  if (!slug || _.isArray(slug)) return;
  const menu = await fetchMenuEntry(slug);
  if (!menu) {
    dispatch(innerErrorMenu());
    return;
  }
  dispatch(innerFetchMenu(menu));
};

export const resetMenus = () => async (dispatch: AppDispatch) => {
  dispatch(innerResetMenus());
};
